import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-grids';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ToastrService } from 'ngx-toastr';
import { GetAggregatorBO, saveHHAXAggregatorCredential } from './agency.model';

@Injectable({
  providedIn: 'root'
})
export class AggregatorService extends Subject<DataStateChangeEventArgs> {
  constructor(private https: HttpClient, public toasterService: ToastrService, public errorService: ErrorService) {
    super();
  }

  saveHHAXCredentialAsync(saveHHAXList:saveHHAXAggregatorCredential): Observable<any> {
    let url = "api/EvvAggregator/saveHHAXCredential?"
    return this.https.post(url, saveHHAXList, { observe: 'response', responseType: "text" },).pipe(
       map(data => data.body),
       catchError(this.errorService.handleError)
    )
  }  
 
  public executeAggregatorFilter(state: GetAggregatorBO): void {
    this.getAggregatorFilter(state).subscribe(x => super.next(x));
  }
  getAggregatorFilter(state?: GetAggregatorBO): Observable<DataStateChangeEventArgs> {
    return this.https.post<any>("api/EvvAggregator/getHHAXCredentialList", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
